<script>import { createEventDispatcher, onDestroy } from "svelte";
import vegaEmbed from "vega-embed";
import { WIDTH_HEIGHT } from "./constants";
import {
  addSignalListenersToView,
  updateMultipleDatasetsInView,
  combineSpecWithDimension,
  computeSpecChanges,
  removeSignalListenersFromView,
  shallowEqual
} from "./utils";
export let options;
export let spec;
export let view;
export let signalListeners = {};
export let data = {};
const dispatch = createEventDispatcher();
let result = void 0;
let prevOptions = {};
let prevSignalListeners = {};
let prevSpec = {};
let prevData = {};
let chartContainer;
$: {
  if (!shallowEqual(data, prevData)) {
    update();
  }
  prevData = data;
}
$: {
  if (chartContainer !== void 0) {
    if (!shallowEqual(options, prevOptions, WIDTH_HEIGHT)) {
      createView();
    } else {
      const specChanges = computeSpecChanges(
        combineSpecWithDimension(spec, options),
        combineSpecWithDimension(prevSpec, prevOptions)
      );
      const newSignalListeners = signalListeners;
      const oldSignalListeners = prevSignalListeners;
      if (specChanges) {
        if (specChanges.isExpensive) {
          createView();
        } else if (result !== void 0) {
          const areSignalListenersChanged = !shallowEqual(newSignalListeners, oldSignalListeners);
          view = result.view;
          if (specChanges.width !== false) {
            view.width(specChanges.width);
          }
          if (specChanges.height !== false) {
            view.height(specChanges.height);
          }
          if (areSignalListenersChanged) {
            if (oldSignalListeners) {
              removeSignalListenersFromView(view, oldSignalListeners);
            }
            if (newSignalListeners) {
              addSignalListenersToView(view, newSignalListeners);
            }
          }
          view.runAsync();
        }
      } else if (!shallowEqual(newSignalListeners, oldSignalListeners) && result !== void 0) {
        view = result.view;
        if (oldSignalListeners) {
          removeSignalListenersFromView(view, oldSignalListeners);
        }
        if (newSignalListeners) {
          addSignalListenersToView(view, newSignalListeners);
        }
        view.runAsync();
      }
    }
    prevOptions = options;
    prevSignalListeners = signalListeners;
    prevSpec = spec;
  }
}
onDestroy(() => {
  clearView();
});
async function createView() {
  clearView();
  try {
    result = await vegaEmbed(chartContainer, spec, options);
    view = result.view;
    if (addSignalListenersToView(view, signalListeners)) {
      view.runAsync();
    }
    onNewView(view);
  } catch (e) {
    handleError(e);
  }
}
function clearView() {
  if (result) {
    result.finalize();
    result = void 0;
    view = void 0;
  }
}
function handleError(error) {
  dispatch("onError", {
    error
  });
  console.warn(error);
}
function onNewView(view2) {
  update();
  dispatch("onNewView", {
    view: view2
  });
}
async function update() {
  if (data && Object.keys(data).length > 0 && result !== void 0) {
    view = result.view;
    updateMultipleDatasetsInView(view, data);
    await view.resize().runAsync();
  }
}
</script>

<div bind:this={chartContainer} />
